import { truncateText } from '@nv/utils'
import { useTranslation } from 'react-i18next'
import styles from './EventDescription.module.scss'

const EventDescription = ({ description, showOneLine = false }) => {
  const { i18n } = useTranslation()
  const currentLanguage = i18n.language
  const translatedDesc = description[currentLanguage]

  return <span className={styles['text']}>{showOneLine ? truncateText(translatedDesc, 40) : translatedDesc}</span>
}

export default EventDescription
